import styled from 'styled-components';

export const Content = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(450px, 1fr));
  gap: 10px;
  padding: 20px 0;
  @media (max-width: 490px) {
    gap: 8px;
    display: flex;
    flex-direction: column;
  }
`;

export const Card = styled.div`
  background: ${({ $gradient }) => $gradient || '#fff'};
  border: 1px solid ${({ $borderColor }) => $borderColor || '#eee'};
  box-shadow:
    0px 4px 6px -4px #0000001a,
    0px 10px 15px -3px #0000001a;
  border-radius: 14px;
  padding: 24px 28px 16px 12px;
  position: relative;
  transition: transform 0.2s ease;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 10px;

  &:hover {
    transform: translateY(-4px);
  }
`;

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  .status-container {
    display: flex;
    align-items: center;
    gap: 10px;
    @media (max-width: 490px) {
      width: 100%;
      margin-bottom: 8px;
      justify-content: end;
    }
  }

  .chevron {
    width: 10px;
    height: 10px;
    cursor: pointer;
  }
  @media (max-width: 490px) {
    flex-direction: column-reverse;
  }
`;

export const UserInfo = styled.div`
  display: flex;
  gap: 16px;
  width: 100%;
`;

export const AvatarWrapper = styled.div`
  width: 56px;
  height: 56px;
  background: #ffffffcc;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow:
    0px 2px 4px -2px #0000001a,
    0px 4px 6px -1px #0000001a;
`;

export const Icon = styled.div`
  width: ${({ $size }) => $size || '28px'};
  height: ${({ $size }) => $size || '28px'};
  background-color: ${({ $color }) => $color};
  mask-image: url(${({ $src }) => $src});
  -webkit-mask-image: url(${({ $src }) => $src});
  mask-size: contain;
  mask-repeat: no-repeat;
  mask-position: center;
  flex-shrink: 0;
`;

export const NameBlock = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  .name-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    margin-bottom: 8px;
    @media (max-width: 1882px) {
      flex-direction: column;
      align-items: start;
      gap: 4px;
    }
    @media (max-width: 1664px) {
      flex-direction: row;
      align-items: center;
      gap: 8px;
    }
    @media (max-width: 1399px) {
      flex-direction: column;
      align-items: start;
      gap: 4px;
    }
    @media (max-width: 953px) {
      flex-direction: row;
      align-items: center;
      gap: 8px;
    }
    @media (max-width: 575px) {
      flex-direction: column;
      align-items: start;
      gap: 4px;
    }
  }
  @media (max-width: 490px) {
    flex: 1;
  }
`;

export const UserName = styled.h3`
  font-size: 18px;
  font-weight: 700;
  color: #212529;
`;

export const CompanyTag = styled.div`
  background: #2b7fff1a;
  color: #2d6cdf;
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 16px;
  font-weight: 500;
  width: fit-content;
  max-width: 120px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  vertical-align: middle;
`;

export const StatusTag = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 2px 10px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;
  background: ${({ $bg }) => $bg};
  color: ${({ $color }) => $color};
  white-space: nowrap;
  ${Icon}:first-child {
    width: 12px;
    height: 12px;
  }
`;

export const InfoGrid = styled.div`
  .info-grid {
    display: flex;
    align-items: center;
    gap: 14px;
    @media (max-width: 450px) {
      flex-direction: column;
      align-items: start;
      gap: 0;
    }
  }
`;

export const InfoItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #6c757d;
  font-size: 14px;
  margin-bottom: 4px;
  font-weight: 400;

  ${Icon} {
    width: 16px;
    height: 16px;
  }
  .color-date {
    color: #212529;
    font-weight: 600;
  }
`;

export const ActionButton = styled.button`
  width: 100%;
  height: 40px;
  background: #2b7fff1a;
  color: #296bcd;
  border: none;
  border-radius: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  cursor: pointer;

  &:hover {
    background: #2d6cdf26;
  }

  ${Icon} {
    width: 18px;
    height: 18px;
  }
`;
export const ByText = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #94a3b8;
  margin-top: 4px;

  ${Icon} {
    width: 14px;
    height: 14px;
  }
`;

export const EmptyContainer = styled.div`
  margin-top: 40px;
`;

export const LocationText = styled.span`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 200px;
  display: inline-block;
`;
